import EventClass from "common/utils/ui/event-class";
import { on as onEvent } from "common/utils/ui/event";

// eslint-disable-next-line import/prefer-default-export
export class SearchDropdownToggleVisibility extends EventClass {
  #props = {};

  #$activeDropdown = null;

  get #$dropdown() {
    return this.#$wrappedForm.querySelector(this.#props.dropdownSelector);
  }

  get #$icon() {
    return this.#$wrappedForm.querySelector(this.#props.iconSelector);
  }

  get #$wrappedForm() {
    return this.#$activeDropdown.closest(this.#props.eventSelector);
  }

  constructor(props) {
    super(props);

    this.#props = props;

    onEvent("click", "body", this.#handleOutsideInteraction.bind(this));
    onEvent("focusin", "body", this.#handleOutsideInteraction.bind(this));
  }

  event(event, $target) {
    super.event(event, $target);

    this.#$activeDropdown = $target;

    this.#showDropdown();
  }

  #hideDropdown() {
    this.#$dropdown?.classList.add("hidden");
    this.#$icon?.classList.remove("text-blue-600!");
  }

  #showDropdown() {
    this.#$dropdown?.classList.remove("hidden");
    this.#$icon?.classList.add("text-blue-600!");
  }

  #handleOutsideInteraction({ target }) {
    if (!this.#$activeDropdown) return;
    if (!this.#$wrappedForm.contains(target)) {
      this.#hideDropdown();
    }
  }
}
